import { useEffect } from 'react';

function useYotpoWidgets() {
  useEffect(() => {
    if (
      typeof (window as any).yotpoWidgetsContainer !== 'undefined' &&
      (window as any).yotpoWidgetsContainer.initWidgets &&
      typeof (window as any).yotpoWidgetsContainer.initWidgets === 'function'
    ) {
      (window as any).yotpoWidgetsContainer.initWidgets();
    }
  }, []);
}

export default useYotpoWidgets;
